
export const escapeCsvValue = (v) => {
    if (v == null) return "";
    const s = String(v);
    if (s.includes(",") || s.includes('"') || s.includes("\n")) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  };
  
  export const downloadChartCSV = (chartData, options = {}) => {
    const { filename = "chart.csv", includeAllDatasets = true, datasetIndex = 0 } = options;
    const labels = Array.isArray(chartData?.labels) ? chartData.labels : [];
    const datasets = Array.isArray(chartData?.datasets) ? chartData.datasets : [];
    if (!datasets.length) return;
  
    let header = [];
    let rows = [];
  
    if (includeAllDatasets) {
      header = ["Label", ...datasets.map((d, i) => d.label || `Series ${i + 1}`)];
      rows = labels.map((lbl, i) => {
        const cols = [escapeCsvValue(lbl)];
        for (let ds of datasets) {
          const val = Array.isArray(ds.data) ? ds.data[i] : "";
          cols.push(escapeCsvValue(val ?? ""));
        }
        return cols.join(",");
      });
    } else {
      const ds = datasets[datasetIndex];
      header = ["Label", ds.label || `Series ${datasetIndex + 1}`];
      rows = labels.map((lbl, i) => {
        const val = Array.isArray(ds.data) ? ds.data[i] : "";
        return [escapeCsvValue(lbl), escapeCsvValue(val ?? "")].join(",");
      });
    }
  
    const csv = [header.join(","), ...rows].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };
 